// Real payment brand logos rendered on clean white chips
const Chip = ({ children, label }) => (
  <span
    className="bg-white rounded-[4px] h-7 w-11 flex items-center justify-center shadow-sm"
    data-testid={`payment-${label.toLowerCase()}`}
    aria-label={label}
  >
    {children}
  </span>
);

export const PaymentIcons = () => (
  <div className="flex items-center gap-2.5">
    <Chip label="Visa">
      <svg viewBox="0 0 48 16" className="h-3.5 w-auto" aria-hidden>
        <text x="0" y="13" fontFamily="Arial, sans-serif" fontSize="15" fontStyle="italic" fontWeight="700" fill="#1434CB" letterSpacing="0.5">VISA</text>
      </svg>
    </Chip>

    <Chip label="Mastercard">
      <svg viewBox="0 0 38 24" className="h-4 w-auto" aria-hidden>
        <circle cx="15" cy="12" r="11" fill="#EB001B" />
        <circle cx="23" cy="12" r="11" fill="#F79E1B" />
        <path d="M19 3.6a11 11 0 010 16.8 11 11 0 010-16.8z" fill="#FF5F00" />
      </svg>
    </Chip>

    <Chip label="Maestro">
      <svg viewBox="0 0 38 24" className="h-4 w-auto" aria-hidden>
        <circle cx="15" cy="12" r="11" fill="#0099DF" />
        <circle cx="23" cy="12" r="11" fill="#ED0006" />
        <path d="M19 3.6a11 11 0 010 16.8 11 11 0 010-16.8z" fill="#6C6BBC" />
      </svg>
    </Chip>

    <Chip label="PayPal">
      <svg viewBox="0 0 56 16" className="h-3.5 w-auto" aria-hidden>
        <text x="0" y="13" fontFamily="Arial, sans-serif" fontSize="14" fontStyle="italic" fontWeight="700" fill="#003087">Pay</text>
        <text x="27" y="13" fontFamily="Arial, sans-serif" fontSize="14" fontStyle="italic" fontWeight="700" fill="#009CDE">Pal</text>
      </svg>
    </Chip>
  </div>
);
